import React from "react";
import PropTypes from "prop-types";

import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";

import {
  useDefaultPasscodeStyles,
  switchControl,
  textfield,
  selectField,
  getSelectedValueTranslated,
  getSelectValues,
  getKeyFromSelectedValue,
} from "../../../constants/passCodeUtils";
import { MIN_DESKTOP_WIDTH } from "../../../constants/ui";

import {
  CONFERENCE_PARTY_ALERT_ACTION,
  CONFERENCE_PARTY_ALERT_ACTION_WARNING_PROMPT,
  PREPAID_FLAG,
  CONFERENCE_PARTY_ALERT_TIMER,
  CONFERENCE_PARTY_ACTION_TIMER,
  PREPAID_SECONDS,
  CONFERENCE_PARTY_ALERT_ALLOW_RESET,
  CONFERENCE_PARTY_ALERT_THRESHOLD,
} from "../../../utils/responseValue";

const PMPrepaidAndAlert = ({ confRestRep, setConfRestRep, selectValues, translate }) => {
  const pc = useDefaultPasscodeStyles();
  const isDesktop = useMediaQuery(`(min-width:${MIN_DESKTOP_WIDTH})`);

  const handleTextChange = name => event => {
    setConfRestRep({ ...confRestRep, [name]: event.target.value });
  };
  const handleSwitchChange = name => event => {
    setConfRestRep({ ...confRestRep, [name]: event.target.checked });
  };
  const handleSelectChange = name => event => {
    setConfRestRep({
      ...confRestRep,
      [name]: getKeyFromSelectedValue(selectValues[name], event.target.value),
    });
  };

  const customStyle = theme => ({
    formControl: {
      width: "200px",
    },
  });

  return (
    <Box component="form" sx={pc.container} noValidate autoComplete="off">
      <Box sx={pc.centerer}>
        {selectField(
          customStyle,
          translate[CONFERENCE_PARTY_ALERT_ACTION],
          getSelectValues(selectValues, CONFERENCE_PARTY_ALERT_ACTION),
          getSelectedValueTranslated(
            confRestRep[CONFERENCE_PARTY_ALERT_ACTION],
            selectValues,
            CONFERENCE_PARTY_ALERT_ACTION
          ),
          handleSelectChange(CONFERENCE_PARTY_ALERT_ACTION),
        isDesktop
        )}
        {selectField(
          customStyle,
          translate[CONFERENCE_PARTY_ALERT_ACTION_WARNING_PROMPT],
          getSelectValues(selectValues, CONFERENCE_PARTY_ALERT_ACTION_WARNING_PROMPT),
          getSelectedValueTranslated(
            confRestRep[CONFERENCE_PARTY_ALERT_ACTION_WARNING_PROMPT],
            selectValues,
            CONFERENCE_PARTY_ALERT_ACTION_WARNING_PROMPT
          ),
          handleSelectChange(CONFERENCE_PARTY_ALERT_ACTION_WARNING_PROMPT),
        isDesktop
        )}
        {selectField(
          customStyle,
          translate[PREPAID_FLAG],
          getSelectValues(selectValues, PREPAID_FLAG),
          getSelectedValueTranslated(confRestRep[PREPAID_FLAG], selectValues, PREPAID_FLAG),
          handleSelectChange(PREPAID_FLAG),
        isDesktop
        )}
      </Box>
      <Box sx={pc.lineBreak} />
      {textfield(
        pc,
        isDesktop,
        confRestRep[CONFERENCE_PARTY_ALERT_THRESHOLD],
        translate[CONFERENCE_PARTY_ALERT_THRESHOLD],
        handleTextChange(CONFERENCE_PARTY_ALERT_THRESHOLD)
      )}
      {textfield(
        pc,
        isDesktop,
        confRestRep[CONFERENCE_PARTY_ALERT_TIMER],
        translate[CONFERENCE_PARTY_ALERT_TIMER],
        handleTextChange(CONFERENCE_PARTY_ALERT_TIMER)
      )}
      <Box sx={pc.lineBreak} />
      {textfield(
        pc,
        isDesktop,
        confRestRep[CONFERENCE_PARTY_ACTION_TIMER],
        translate[CONFERENCE_PARTY_ACTION_TIMER],
        handleTextChange(CONFERENCE_PARTY_ACTION_TIMER)
      )}
      {textfield(
        pc,
        isDesktop,
        confRestRep[PREPAID_SECONDS],
        translate[PREPAID_SECONDS],
        handleTextChange(PREPAID_SECONDS)
      )}
      <Box sx={pc.lineBreak} />
      {switchControl(
        pc,
        confRestRep[CONFERENCE_PARTY_ALERT_ALLOW_RESET],
        CONFERENCE_PARTY_ALERT_ALLOW_RESET,
        translate[CONFERENCE_PARTY_ALERT_ALLOW_RESET],
        handleSwitchChange(CONFERENCE_PARTY_ALERT_ALLOW_RESET)
      )}
      <Box sx={pc.lineBreak} />
    </Box>
  );
};

PMPrepaidAndAlert.propTypes = {
  confRestRep: PropTypes.object.isRequired,
  selectValues: PropTypes.object.isRequired,
  setConfRestRep: PropTypes.func.isRequired,
  translate: PropTypes.object.isRequired,
};

export default PMPrepaidAndAlert;
